import { Component } from '@angular/core';
import { JhiLanguageService } from 'ng-jhipster';

@Component({
  selector: 'jhi-maintenance',
  templateUrl: './maintenance.component.html',
})
export class MaintenanceComponent {

    constructor( private jhiLanguageService: JhiLanguageService) {
        this.jhiLanguageService.setLocations(['maintenance']);
     }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/maintenance/maintenance.component.ts